import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

import { useState } from "react"

import { strings } from "../../strings"
import '../../styling/checkboxes.css'
import '../../styling/dialog.css'

const ConfirmationDialog = ({ open, closeConfirm, closeCancel, event }) => {

    const [machine1, setMachine1] = useState(false)
    const [machine2, setMachine2] = useState(false)

    const month = event && event.start.getMonth() + 1
    const end = event && new Date(event.start.getTime() + 90*60000);
    const startMinutes = event && ('0'+ event.start.getMinutes()).slice(-2)
    const endMinutes = event && ('0'+ end.getMinutes()).slice(-2)
    const dateFormat = event && event.start.getDate() + "/" + month + ", " + event.start.getHours() + ":" + startMinutes + "-" + end.getHours() + ":" + endMinutes

    let w = window.innerWidth
    let h = window.innerHeight

    const onCheckMachine1 = (e) => {
        setMachine1(e.target.checked)
    }

    const onCheckMachine2 = (e) => {
        setMachine2(e.target.checked)
    }

    return (
        <Dialog className="confirmation-dialog" open={open}>
            <DialogTitle style={{ width: `${w > h ? '30vw' : '65vw'}` }}>{strings.dialogs.confirmationTitle}</DialogTitle>
            <DialogContent >
                <DialogContentText>
                    {event && event.facility}
                    <br /> <br />
                </DialogContentText>

                <div className='machineCheckboxes'>
                    <label style={{ display: event && event.machineID !== 1 ? 'none' : '' }}
                        className="container">{event && strings.dialogs.oneBookedBy + event.userName}
                    </label>
                    <label style={{ display: event && event.machineID === 1 ? 'none' : '' }}
                        className="container">{strings.laundry.machine1}
                        <input onClick={onCheckMachine1}
                            type="checkbox"
                            id='firstMachine'
                            defaultChecked={machine1} />
                        <span className="checkmark"></span>
                    </label>
                    <br />
                    <label style={{ display: event && event.machineID !== 2 ? 'none' : '' }}
                        className="container">{event && strings.dialogs.twoBookedBy + event.userName}
                    </label>
                    <label style={{ display: event && event.machineID === 2 ? 'none' : '' }}
                        className="container">{strings.laundry.machine2}
                        <input onClick={onCheckMachine2}
                            type="checkbox"
                            id='secondMachine'
                            defaultChecked={machine2} />
                        <span className="checkmark"></span>
                    </label>
                </div>

                <DialogContentText>
                    <br />
                    {event && dateFormat}
                </DialogContentText>

            </DialogContent>
            <DialogActions className="dialog-actions">
                <span className="cancel-dialog" onClick={closeCancel} style={{ cursor: "pointer" }}>
                    {strings.dialogs.cancel}
                </span>
                <span className={`${(machine1 || machine2) ? "confirm-dialog" : "confirm-dialog-disabled"}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => closeConfirm(machine1, machine2)} >
                    {strings.dialogs.confirmation}
                </span>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmationDialog
